import { DestroyRef, inject, Injector, SimpleChanges, ViewContainerRef } from '@angular/core';
import { takeWhileAlive } from '../../../utils';
import { isEqualDeep } from '@core/shared/utils';
import { DynamicComponentHelper, DynamicComponentIOCheck } from '../../../dynamic-components';
import { FeatureWidgetsRegistry } from '../../widgets';
import * as i0 from "@angular/core";
import * as i1 from "../../widgets";
function CoreWidgetComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
/**
 */
/**
 * WidgetDirective is a structural directive which should be used on ng-container.
 * <ng-container *widgetPosition="{id:'...',inputs,outputs}"></ng-container>
 * It will use FeatureRegistry to find all components assigned to it's ID and render them in place.
 *
 * However, most of the time you will simply be using <core-widget> component.
 */
export let CoreWidgetDirective = /*#__PURE__*/(() => {
  class CoreWidgetDirective {
    set _config(config) {
      this.config = {
        inputs: {},
        outputs: {},
        ...config
      };
    }
    constructor(injector, vcr,
    // private dynamicComponentsService: FeatureDynamicComponentsService,
    featureWidgets) {
      this.injector = injector;
      this.vcr = vcr;
      this.featureWidgets = featureWidgets;
      this.destroyRef = inject(DestroyRef);
      this.componentRefs = [];
      this.defaultComponentContext = {};
      this.componentBindings = [];
    }
    ngOnInit() {
      this.featureWidgets.getContentWidgets$(this.config.id).pipe(takeWhileAlive(this.destroyRef)).subscribe(manifests => {
        this.createCustomComponents(manifests.map(m => m.componentInfo));
      });
      // this.dynamicComponentsService
      // 	.resolveWidgetComponents(this.config.id)
      // 	.pipe(takeWhileAlive(this.destroyRef))
      // 	.subscribe((componentInfos) => {
      // 		this.componentInfos = componentInfos;
      // 		this.createCustomComponents();
      // 	})
    }
    ngOnChanges(changes) {
      if (changes?.data?.currentValue?.inputs) {
        this.updateAllComponentInputs();
      }
    }
    /*********************************
     * Handling of custom component
     *********************************/
    clearBindings() {
      this.componentBindings.forEach(binding => binding.next(true));
      this.componentBindings = [];
    }
    createCustomComponents(componentInfos) {
      this.clearBindings();
      this.removeDefaultComponent();
      componentInfos.forEach(componentInfo => {
        const config = {
          // validation is not used for widgets as widgets are allowed to only "take what they need"
          IOCheck: DynamicComponentIOCheck.None,
          ...this.config,
          component: componentInfo
        };
        const {
          componentRef,
          destroyBindings
        } = DynamicComponentHelper.makeCustomComponent(config, this.injector, this.vcr);
        this.componentBindings.push(destroyBindings);
        this.componentRefs.push(componentRef);
      });
      this.updateAllComponentInputs();
    }
    /*********************************
     * Handling of default component/template
     *********************************/
    removeDefaultComponent() {
      this.vcr.clear();
      this.componentRefs.forEach(ref => {
        ref?.destroy();
      });
      this.componentRefs = [];
    }
    /*********************************
     * Manage Input/Output bindings
     *********************************/
    updateAllComponentInputs() {
      if (!this.componentRefs.length || !this.config.inputs) return;
      const {
        inputs
      } = this.config;
      if (inputs) {
        // all components receive same params. Check for changes on first component only.
        this.componentRefs.forEach(ref => {
          // eslint-disable-next-line guard-for-in
          for (const key in this.config.inputs) {
            // check if component actually has that input mapped, skip if not
            if (!ref.inputs.find(input => {
              return input.propName === key;
            })) continue;
            if (!isEqualDeep(ref.instance[key], inputs[key])) {
              ref.setInput(key, inputs[key]);
            }
          }
        });
      }
    }
    static {
      this.ɵfac = function CoreWidgetDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreWidgetDirective)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.FeatureWidgetsRegistry));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: CoreWidgetDirective,
        selectors: [["", "widgetPosition", ""]],
        inputs: {
          _config: [0, "widgetPosition", "_config"]
        },
        features: [i0.ɵɵProvidersFeature([]), i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return CoreWidgetDirective;
})();
export let CoreWidgetComponent = /*#__PURE__*/(() => {
  class CoreWidgetComponent {
    static {
      this.ɵfac = function CoreWidgetComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreWidgetComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoreWidgetComponent,
        selectors: [["core-widget"]],
        inputs: {
          widget: "widget"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "widgetPosition"]],
        template: function CoreWidgetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CoreWidgetComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("widgetPosition", ctx.widget);
          }
        },
        dependencies: [CoreWidgetDirective],
        encapsulation: 2
      });
    }
  }
  return CoreWidgetComponent;
})();